import TimingIcon from "@mui/icons-material/ScheduleRounded";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import InlineAttribute from "../../../../common/InlineAttribute";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationSettingsTile from "./InvestorCommunicationSettingsTile";

const InvestorCommunicationTimingTile = () => {
  const { investorCommunication, hasEditPermissions, onTabChange } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  const { publishedAt, publishedToLiveAt, isPublishedAtCustom } = investorCommunication;
  const publishDateOptionLabel = isPublishedAtCustom ? "Custom date" : "Make Live";
  const shownPublishedAt = isPublishedAtCustom ? publishedAt : publishedToLiveAt;

  return (
    <InvestorCommunicationSettingsTile
      title="Timing"
      Icon={TimingIcon}
      hideView
      onEdit={hasEditPermissions ? () => onTabChange("timing") : undefined}
    >
      <InlineAttribute
        label="Publish date"
        labelWidth="12.5rem"
        value={
          shownPublishedAt
            ? `${publishDateOptionLabel} • ${convertISODateTime(shownPublishedAt)}`
            : publishDateOptionLabel
        }
      />
    </InvestorCommunicationSettingsTile>
  );
};

export default InvestorCommunicationTimingTile;
